<template>
  <div v-if="selectedStage" class="candidates-list" v-loading="loading">
    <CandidateItem
      v-for="(item, index) in candidates"
      :key="`${item.id}_${index}`"
      :candidate="item"
    />
  </div>
</template>
<script>
import { getController } from '@/controllers/request.js';
import { store } from '@/store';
import CandidateItem from 'Parts/Candidate/Item/CandidateItemSmall';
export default {
  data() {
    return {
      candidates: [],
      loading: false
    };
  },
  created() {
    this.loading = true;

    getController({
      url: `index.php?module=HRPAC_VACANCY&action=getCandidatesStageWithMassActions&vacancy_id=${this.selectedStage.vacancy_id}&stage_id=${this.selectedStage.id}&to_pdf=true`
    })
      .then(resp => {
        this.candidates = resp.data.candidates;
        store.commit('massAction/setCandidates', resp.data.candidates);
        store.commit('massAction/setActions', resp.data.MassActions);
      })
      .catch(err =>
        this.catchError(
          err,
          'Возникла ошибка при получении кандидатов по этапу',
          'get candidates by stage'
        )
      )
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    selectedStage() {
      return store.state.vacancy.selectedStage || {};
    }
  },
  components: { CandidateItem }
};
</script>
<style lang="scss" scoped>
.candidates-list {
  padding: 20px;
}
</style>
